import * as React from 'react';

import AccreditedInvestorProfilePage from '@buyside/components/presentation/AccreditedInvestorProfilePage/accreditedInvestorProfilePage';
import LoadingSpinner, {
  SIZES
} from '@buyside/components/presentation/LoadingSpinner/loadingSpinner';

import {
  useCreateOrUpdateAccreditedInvestorProfileMutation,
  useCurrentUserAccreditedInvestorProfileQuery
} from '@interfaces/graphql-typings';

const AccreditedInvestorProfilePageContainer: React.FunctionComponent = (): React.ReactElement | null => {
  const { data, loading: userLoading } = useCurrentUserAccreditedInvestorProfileQuery();

  const [
    createOrUpdateAccreditedInvestorProfile,
    { loading }
  ] = useCreateOrUpdateAccreditedInvestorProfileMutation();

  const userId = data?.currentUser?.id;
  const accreditedInvestorProfile = data?.currentUser?.accreditedInvestorProfile;

  if (userLoading) return <LoadingSpinner size={SIZES.LARGE} />;

  if (!userId) return null;

  return (
    <AccreditedInvestorProfilePage
      accreditedInvestorProfile={accreditedInvestorProfile}
      createOrUpdateAccreditedInvestorProfile={createOrUpdateAccreditedInvestorProfile}
      isLoading={loading}
      userId={userId}
    />
  );
};

export default AccreditedInvestorProfilePageContainer;
